import { isValidDate } from '@sales-center/common'
import { GridValueFormatterParams } from '@mui/x-data-grid-pro'
import { differenceInDays } from 'date-fns/esm'

export const ageValueFormatter = ({ value }: GridValueFormatterParams): any => {
  if ((!!value && typeof value === 'string') || isValidDate(value)) {
    const diff = differenceInDays(new Date(), new Date(value))
    const label = diff === 1 ? 'day' : 'days'
    return `${diff} ${label}`
  } else if (typeof value === 'number') {
    return `${value} ${value === 1 ? 'day' : 'days'}`
  }

  return ''
}
